import { render, staticRenderFns } from "./RightBottom.vue?vue&type=template&id=714b476f&scoped=true&"
import script from "./RightBottom.vue?vue&type=script&lang=js&"
export * from "./RightBottom.vue?vue&type=script&lang=js&"
import style0 from "./RightBottom.vue?vue&type=style&index=0&id=714b476f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714b476f",
  null
  
)

export default component.exports